module.exports = __webpack_public_path__ + "img/25.7.Chla.9f407768.png";